import { getPlatformLabel } from '../platforms/identity';

export interface SchedulePartitionInput {
  platform: string;
  canPublish: boolean;
  blockingMessage?: string | null;
}

export interface SkippedPlatform {
  platform: string;
  reason: string;
}

export interface SchedulePartition {
  ready: string[];
  skipped: SkippedPlatform[];
}

export function partitionScheduleReadiness(
  results: readonly SchedulePartitionInput[],
): SchedulePartition {
  const ready: string[] = [];
  const skipped: SkippedPlatform[] = [];
  for (const result of results) {
    if (result.canPublish) {
      ready.push(result.platform);
      continue;
    }
    skipped.push({
      platform: result.platform,
      reason:
        result.blockingMessage?.trim() || `${getPlatformLabel(result.platform)} is not ready.`,
    });
  }
  return { ready, skipped };
}

function joinLabels(platforms: readonly string[]): string {
  const labels = platforms.map((platform) => getPlatformLabel(platform));
  if (labels.length <= 1) return labels.join('');
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
}

export function describeScheduleOutcome(partition: SchedulePartition): {
  title: string;
  skippedLines: string[];
} {
  const title = `Scheduled for ${joinLabels(partition.ready)}.`;
  return { title, skippedLines: partition.skipped.map((entry) => entry.reason) };
}
